import { render, staticRenderFns } from "./SuggestRoleTicketItem.vue?vue&type=template&id=2c5cd2c6&"
import script from "./SuggestRoleTicketItem.vue?vue&type=script&lang=js&"
export * from "./SuggestRoleTicketItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports